module.exports = __webpack_public_path__ + "img/character_creator_button.30c63b1b.png";